import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { GreenTick, RedCross, RedFlag } from '../../../../static/img/images'
import { fetchQuestion, fetchQuestionReset, fetchSchoolSubtopicSkillReport, selectClass, selectStudent, subtopicReportReset } from '../../../../store/actions'
import './style.scss'
import { textIdentifier } from '../../../../textIdentifier'

function CustomSkillTable(props) {
    const [pageSize, setPageSize] = useState(10)
    const [pageNumber, setpageNumber] = useState(0)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedCompetition, selectedSchool, activeQuestion,lang } = useSelector(
        (state) => state.main
      );
    const goPrevious = () => {
        dispatch(fetchSchoolSubtopicSkillReport({
            schoolId: selectedSchool.id,
            nodeId: props.activeTopic.nodeId,
            params: {
              limit: pageSize,
              offset: Number((pageNumber-1)*pageSize)
            },
            activeTopicData: {
              name: props.activeTopic.name,
              totalMarks: props.activeTopic.totalMarks,
              totalQuestions: props.activeTopic.totalQuestions,
              nodeId: props.activeTopic.nodeId,
            }
        }))
        setpageNumber(pageNumber-1)
    }

    const goNext = () => {
        dispatch(fetchSchoolSubtopicSkillReport({
            schoolId: selectedSchool.id,
            nodeId: props.activeTopic.nodeId,
            params: {
              limit: pageSize,
              offset: Number((pageNumber+1)*pageSize)
            },
            activeTopicData: {
              name: props.activeTopic.name,
              totalMarks: props.activeTopic.totalMarks,
              totalQuestions: props.activeTopic.totalQuestions,
              nodeId: props.activeTopic.nodeId,
            }
        }))
        setpageNumber(pageNumber+1)
    }

    const handleNameClick = (data) => {
        // let len = props.data.results.length
        // dispatch(selectClass({ code: data.class_code }))
        // dispatch(selectStudent({ ...data, len }));
        navigate(`/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes/?student=${data.student_id}&classCode=${data.class_code}`);
        dispatch(subtopicReportReset())
    }
    
    const handleQuestionClick = (data) => {
        dispatch(fetchQuestion({
            ctId: data.ct_id
        }))
    }
    const closeQuestion = () => {
        dispatch(fetchQuestionReset())
    }

    const handlePageSizeChange = (size) => {
        setPageSize(size)
        dispatch(fetchSchoolSubtopicSkillReport({
            schoolId: selectedSchool.id,
            nodeId: props.activeTopic.nodeId,
            params: {
              limit: size,
              offset: 0
            },
            activeTopicData: {
              name: props.activeTopic.name,
              totalMarks: props.activeTopic.totalMarks,
              totalQuestions: props.activeTopic.totalQuestions,
              nodeId: props.activeTopic.nodeId,
            }
        }))
        setpageNumber(0)
    }

  return (
    <div className="custom--table--wrapper">
        <div className="info--wrapper" style={{marginBottom:"42px",height: "32px"}}>
            {/* <div className="info--card">
                <p>Topic Name: <b>{!!props.activeTopic && props.activeTopic.name}</b></p>
                <p>Total Questions = <b>{!!props.activeTopic && props.activeTopic.totalQuestions}</b></p>
                <p>Total Marks = <b>{!!props.activeTopic && props.activeTopic.totalMarks}</b></p>
            </div> */}
            <div style={{position:"absolute",right:0}} className="list--length--select">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M7.5 6C7.5 6.39782 7.34196 6.77936 7.06066 7.06066C6.77936 7.34196 6.39782 7.5 6 7.5C5.60218 7.5 5.22064 7.34196 4.93934 7.06066C4.65804 6.77936 4.5 6.39782 4.5 6C4.5 5.60218 4.65804 5.22064 4.93934 4.93934C5.22064 4.65804 5.60218 4.5 6 4.5C6.39782 4.5 6.77936 4.65804 7.06066 4.93934C7.34196 5.22064 7.5 5.60218 7.5 6V6Z" stroke="#0059B1" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M1.229 6C1.866 3.9715 3.7615 2.5 6 2.5C8.239 2.5 10.134 3.9715 10.771 6C10.134 8.0285 8.239 9.5 6 9.5C3.7615 9.5 1.866 8.0285 1.229 6V6Z" stroke="#0059B1" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <select
                    value={pageSize}
                    onChange={e => {
                        handlePageSizeChange(Number(e.target.value))
                    }}
                    >
                    {[10,25,50].map(pageSize => (
                        <option key={pageSize} value={pageSize}>
                        {pageSize}
                        </option>
                    ))}
                </select>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th rowSpan={2}>{textIdentifier["students"][lang]}</th>
                    {
                        ("results" in props.data)
                        &&
                        props.data.results[0].questions.map((item,index)=>(
                            <th className='skill--heading'>
                                {item.skill}
                            </th>
                        ))
                    }
                </tr>
                <tr>
                    {
                        ("results" in props.data)
                        &&
                        props.data.results[0].questions.map((item,index)=>(
                            <th onClick={()=>{handleQuestionClick(item)}} style={{cursor:'pointer', color: "#0059b1"}}>
                                {`Q${index+1}`}
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    ("results" in props.data)
                    &&
                    props.data.results.map((item,index)=>(
                        <tr>
                            <td>
                                <div onClick={()=>{handleNameClick(item)}} className="data--cell topic--name--wrapper">
                                <div className="topic--name">
                                {`${item.student_first_name} ${item.student_last_name}`}
                                </div>
                                {
                                    index<5 && pageNumber==0
                                    &&
                                    <RedFlag/>
                                }
                                </div>
                            </td>
                            {
                                item.questions.map((itm,ind)=>(
                                    <td className='skill--indicator'>
                                        {
                                            itm.status == 0 ? <RedCross/> :
                                            itm.status == 1 ? <GreenTick/> :
                                            itm.status == 2 ? "NA" : null
                                        }
                                    </td>
                                ))
                            }
                        </tr>
                    ))
                }
            </tbody>
        </table>
        <div className='pagination'>
          <button onClick={() => {goPrevious()}} disabled={pageNumber==0 && (!!props.data && props.data.previous==null)}>
            &#10094;{' '}
            {textIdentifier["previous-page"][lang]}
          </button>{' '}
          <button onClick={() => {goNext()}} disabled={!!props.data && props.data.next==null}>
          {textIdentifier["next-page"][lang]}
           {' '}&#10095;
          </button>{' '}

        </div>
        {
            !!activeQuestion
            &&
            <div className='question--wrapper'>
                <div className='question--header'>
                    <span>{textIdentifier["question"][lang]}</span>
                    <span onClick={()=>{closeQuestion()}} className='close-btn'>&times;</span>
                </div>
                <div className='question--body'>
                  <div
                        dangerouslySetInnerHTML={{
                            __html: decodeURIComponent(atob(activeQuestion.question).split('').map(function (c) {
                                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                            }).join(''))
                        }}
                    />
                    <div 
                        dangerouslySetInnerHTML={{
                            __html: decodeURIComponent(atob(activeQuestion.answer_type).split('').map(function (c) {
                                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                            }).join(''))
                        }}
                    />
                </div>
            </div>
        }
    </div>
  )
}

export default CustomSkillTable